import React, { useState, useEffect } from "react";
import { Plus, Pencil, Trash2, X, Save } from "lucide-react";
import { api } from "../lib/api";
import ImageUpload from "./ImageUpload";

const empty = { image: "", category: "Workshop", title_pt: "", title_en: "", order: 0 };
const CATEGORIES = ["Workshop", "Competition", "Technical", "Parts"];

const GalleryManager = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  const load = () => api.listGallery().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm({ ...empty, order: items.length + 1 }); setEditing("new"); };
  const openEdit = (it) => { setForm({ ...it }); setEditing(it.id); };
  const close = () => { setEditing(null); setForm(empty); };
  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    if (!form.image) { alert("Escolha uma imagem."); return; }
    setSaving(true);
    try {
      if (editing === "new") await api.createGallery(form);
      else await api.updateGallery(editing, form);
      await load();
      close();
    } catch { alert("Erro ao guardar."); }
    finally { setSaving(false); }
  };

  const remove = async (id) => {
    if (!window.confirm("Eliminar esta foto?")) return;
    setItems((p) => p.filter((i) => i.id !== id));
    try { await api.deleteGallery(id); } catch { load(); }
  };

  const inputCls = "bf-input w-full rounded-xl px-4 py-2.5 text-sm placeholder:text-gray-500";
  const labelCls = "block text-xs font-medium text-gray-400 mb-1.5";

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <p className="text-gray-400 text-sm">{items.length} foto(s) na galeria</p>
        <button onClick={openNew} className="bf-btn-primary text-white font-semibold px-5 py-2.5 rounded-xl inline-flex items-center gap-2 text-sm">
          <Plus className="w-4 h-4" /> Nova Foto
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map((it) => (
          <div key={it.id} className="bf-glass rounded-2xl overflow-hidden group">
            <div className="relative aspect-square">
              <img src={it.image} alt={it.title_pt} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                <button onClick={() => openEdit(it)} className="p-2 rounded-lg bg-white/10 text-white hover:text-[#67e8f9]"><Pencil className="w-4 h-4" /></button>
                <button onClick={() => remove(it.id)} className="p-2 rounded-lg bg-red-500/20 text-red-300"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
            <div className="p-3">
              <span className="text-[#67e8f9] text-[10px] uppercase tracking-wide">{it.category}</span>
              <p className="text-white text-sm font-medium truncate">{it.title_pt || "—"}</p>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 z-[70] bg-black/70 flex items-center justify-center p-4" onClick={close}>
          <div className="bf-glass rounded-2xl p-6 w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-5">
              <h3 className="text-white font-bold text-lg">{editing === "new" ? "Nova Foto" : "Editar Foto"}</h3>
              <button onClick={close} className="text-gray-400 hover:text-white"><X className="w-5 h-5" /></button>
            </div>
            <form onSubmit={save} className="space-y-4">
              <ImageUpload value={form.image} onChange={(url) => setForm({ ...form, image: url })} label="Foto *" />
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className={labelCls}>Título (PT)</label>
                  <input name="title_pt" value={form.title_pt} onChange={onChange} className={inputCls} />
                </div>
                <div>
                  <label className={labelCls}>Título (EN)</label>
                  <input name="title_en" value={form.title_en} onChange={onChange} className={inputCls} />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className={labelCls}>Categoria</label>
                  <select name="category" value={form.category} onChange={onChange} className={inputCls}>
                    {CATEGORIES.map((c) => <option key={c} value={c} className="bg-[#131b32]">{c}</option>)}
                  </select>
                </div>
                <div>
                  <label className={labelCls}>Ordem</label>
                  <input type="number" name="order" value={form.order} onChange={onChange} className={inputCls} />
                </div>
              </div>
              <button type="submit" disabled={saving} className="bf-btn-primary text-white font-semibold px-6 py-3 rounded-xl w-full inline-flex items-center justify-center gap-2 text-sm disabled:opacity-60">
                <Save className="w-4 h-4" /> {saving ? "A guardar..." : "Guardar"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryManager;
